import { render } from "./JITAdminProcess.vue?vue&type=template&id=8cec2b10&scoped=true"
import script from "./JITAdminProcess.vue?vue&type=script&lang=js"
export * from "./JITAdminProcess.vue?vue&type=script&lang=js"

import "./JITAdminProcess.vue?vue&type=style&index=0&id=8cec2b10&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cec2b10"]])

export default __exports__